<template>
    <FavoritedText v-if="isFavorited && !isTakingEvaluationAction" />
    <SkippedText v-else-if="isSkipped && !isTakingEvaluationAction" />
</template>

<script>
import FavoritedText from './FavoritedText'
import SkippedText from './SkippedText'
import { mapGetters } from 'vuex'

export default {
    components: { FavoritedText, SkippedText },    

    computed: {
        ...mapGetters('athleteProfile', [
            'isFavorited',
            'isSkipped',
            'isTakingEvaluationAction',
        ]),
    }
}
</script>